// extracted by mini-css-extract-plugin
module.exports = {"title":"title_18S","h1":"h1_DrA","h2":"h2_4sY","h3":"h3_2uq","h4":"h4_Jxj","h5":"h5_1k4","h6":"h6_2tU"};